// extracted by mini-css-extract-plugin
export default {"hero":"SolutionsHero_hero__yGJGb","title":"SolutionsHero_title__7vITX","highlight":"SolutionsHero_highlight__pCVoc","body":"SolutionsHero_body__K3Pn-"};